import {gql, useQuery} from "@apollo/client";

export const CONTACT_INFO_QUERY = gql`
    query GetLinkedContactInfoApi {
        contact {
            id
            contactId
            name
            contactType {
                id
                name
            }
        }
    }
`;

export interface LinkedContactInfo {
  id: number;
  contactId: string;
  name: string;
  contactType: {
    id: string;
    name: string;
  };
}

export interface LinkedContactInfoQuery {
  contact: LinkedContactInfo;
}

export const useGetLinkedContactInfo = () => {
  const {loading, error, data} = useQuery<LinkedContactInfoQuery>(CONTACT_INFO_QUERY,);

  return {
    loading: loading,
    error: error,
    data: data && data.contact
  };
};